// Small deterministic PRNG so seed → data is reproducible.
// Mulberry32 — one of the fastest good-quality 32-bit generators.

export function makeRng(seed = 42) {
  let s = seed >>> 0;
  return () => {
    s |= 0;
    s = (s + 0x6d2b79f5) | 0;
    let t = Math.imul(s ^ (s >>> 15), 1 | s);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export type Rng = ReturnType<typeof makeRng>;

export const int = (rng: Rng, min: number, max: number) =>
  Math.floor(rng() * (max - min + 1)) + min;

export const pick = <T>(rng: Rng, arr: readonly T[]): T =>
  arr[Math.floor(rng() * arr.length)]!;

export const chance = (rng: Rng, pct: number) => rng() * 100 < pct;

export const walk = (rng: Rng, base: number, jitter: number, min = 0, max = Infinity) =>
  Math.max(min, Math.min(max, base + (rng() - 0.5) * 2 * jitter));
